import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import centerProfile from '../views/pages/centerProfile.vue'
// import exam from '../views/pages/exam.vue'
import trainSign from '../views/pages/trainSign.vue'
// import IACUC from '../views/pages/IACUC.vue'
// import animalApply from '../views/pages/animalApply.vue'
// import instrument from '../views/pages/instrument.vue'
// import consumable from '../views/pages/consumable.vue'
// import instrumentDetail from '../views/pages/instrumentDetail.vue'
// import consumableDetail from '../views/pages/consumableDetail.vue'
// import scientific from '../views/pages/scientific.vue'
// import guide from '../views/pages/guide.vue'
// import notice from '../views/pages/notice.vue'
// import downLoad from '../views/pages/downLoad.vue'
// import login from '../views/pages/login/index.vue'
// import register from '../views/pages/login/register.vue'
// import core from '../views/pages/core.vue'
// import workbench from '../views/pages/coreDetail/workbench.vue'
// import training from '../views/pages/coreDetail/training.vue'
// import onlineExam from '../views/pages/coreDetail/onlineExam.vue'
// import welfare from '../views/pages/coreDetail/welfare.vue'
// import reviewChange from '../views/pages/coreDetail/reviewChange.vue'
// import aniApplication from '../views/pages/coreDetail/aniApplication.vue'
// import examDetail from '../views/pages/examDetail.vue'
// import operationRoom from '../views/pages/operationRoom.vue'
// import instrumentCore from '../views/pages/coreDetail/instrument.vue'
// import operationRoomCore from '../views/pages/coreDetail/operationRoom.vue'
// import deliveryTest from '../views/pages/coreDetail/deliveryTest.vue'
// import consumableCore from '../views/pages/coreDetail/consumableCore.vue'
// import expense from '../views/pages/coreDetail/expense.vue'
// import research from '../views/pages/coreDetail/research.vue'
// import ethicsChange from '../views/pages/coreDetail/ethicsChange.vue'
// import personalData from '../views/pages/coreDetail/personalData.vue'
// import opeRecord from '../views/pages/coreDetail/opeRecord'
// import aniExpense from '../views/pages/coreDetail/aniExpense'
// import entryMsg from '../views/pages/coreDetail/entryMsg'
// import integrityRecord from '../views/pages/coreDetail/integrityRecord'
// import monthlySum from '../views/pages/coreDetail/monthlySum'
// import ownLimit from '../views/pages/coreDetail/ownLimit'
// import experData from '../views/pages/coreDetail/experData'
// import noticeRichDetail from '../views/pages/noticeRichDetail'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: () => import('@/views/Home.vue'),
		 meta: { title: '首页', keepAlive: true },
	},
	{
		path: '/centerProfile',
		name: 'centerProfile',
		// component:  () => import('@/views/pages/centerProfile.vue'),
		component:centerProfile,
		meta: { title: '平台简介', keepAlive: true },
	},
	{
		path: '/exam',
		name: 'exam',
		component: () => import('@/views/pages/exam.vue'),
		meta: { title: '考试中心', keepAlive: true },
	},
	{
		path: '/examDetail',
		name: 'examDetail',
		component: () => import('@/views/pages/examDetail.vue'),
		meta: { title: '试卷详情', keepAlive: true },
	},
	{
		path: '/trainSign',
		name: 'trainSign',
		component: () => import('@/views/pages/trainSign.vue'),
		// component:trainSign,
		meta: { title: '培训报名', keepAlive: true },
	},
	{
		path: '/IACUC',
		name: 'IACUC',
		component: () => import('@/views/pages/IACUC.vue'),
		meta: { title: 'IACUC审查', keepAlive: true },
	},
	{
		path: '/IACUCPDF',
		name: 'IACUCPDF',
		component: () => import('@/views/pages/IACUCPDF.vue'),
		meta: { title: '伦理申请表导出', keepAlive: true },
	},
	{
		path: '/expensePdf',
		name: 'expensePdf',
		component: () => import('@/views/pages/expensePdf.vue'),
		meta: { title: '费用明细导出', keepAlive: true },
	},
	{
		path: '/animalApply',
		name: 'animalApply',
		component: () => import('@/views/pages/animalApply.vue'),
		meta: { title: '动物订购申请', keepAlive: true },
	},
	{
		path: '/aniQualification',
		name: 'aniQualification',
		component: () => import('@/views/pages/aniQualification.vue'),
		meta: { title: '动物中心入室申请', keepAlive: true },
	},
	{
		path: '/instrument',
		name: 'instrument',
		component: () => import('@/views/pages/instrument.vue'),
		meta: { title: '仪器预约', keepAlive: true },
	},
	{
		path: '/instrument2',
		name: 'instrument2',
		component: () => import('@/views/pages/instrument.vue'),
		meta: { title: '仪器预约', keepAlive: true },
	},
	{
		
		path: '/consumable',
		name: 'consumable',
		component: () => import('@/views/pages/consumable.vue'),
		meta: { title: '耗材&项目', keepAlive: true},
	},
	{
		path: '/operationRoom',
		name: 'operationRoom',
		component: () => import('@/views/pages/operationRoom.vue'),
		meta: { title: '场地预约', keepAlive: true },
	},
	{
		path: '/accessControl',
		name: 'accessControl',
		component: () => import('@/views/pages/accessControl.vue'),
		meta: { title: '门禁预约', keepAlive: true },
	},
	{
		path: '/accessControl2',
		name: 'accessControl2',
		component: () => import('@/views/pages/accessControl.vue'),
		meta: { title: '门禁预约', keepAlive: true },
	},
	{
		path: '/instrumentDetail',
		name: 'instrumentDetail',
		component: () => import('@/views/pages/instrumentDetail.vue'),
		meta: { title: '仪器详情', keepAlive: true },
	},
	{
		
		path: '/consumableDetail',
		name: 'consumableDetail',
		component: () => import('@/views/pages/consumableDetail.vue'),
		meta: { title: '耗材&项目详情', keepAlive: true },
	},
	{
		path: '/scientific',
		name: 'scientific',
		component: () => import('@/views/pages/scientific.vue'),
		meta: { title: '科研服务', keepAlive: true },
	},
	{
		path: '/guide',
		name: 'guide',
		component: () => import('@/views/pages/guide.vue'),
		meta: { title: '服务指南', keepAlive: true },
	},
	{
		path: '/notice',
		name: 'notice',
		component: () => import('@/views/pages/notice.vue'),
		meta: { title: '公告资讯', keepAlive: true },
	},
	{
		path: '/notice2',
		name: 'notice2',
		component: () => import('@/views/pages/notice.vue'),
		meta: { title: '公告资讯', keepAlive: true },
	},
	{
		path: '/noPermission',
		name: 'noPermission',
		component: () => import('@/views/pages/noPermission.vue'),
		meta: { title: '暂无权限', keepAlive: true },
	},
	{
		
		path: '/downLoad',
		name: 'downLoad',
		component: () => import('@/views/pages/downLoad.vue'),
		meta: { title: '下载中心', keepAlive: true },
	},
	{
		
		path: '/downLoad2',
		name: 'downLoad2',
		component: () => import('@/views/pages/downLoad.vue'),
		meta: { title: '下载中心', keepAlive: true },
	},
	{
		
		path: '/login',
		name: 'login',
		component: () => import('@/views/pages/login/index.vue'),
		meta: { title: '登录', keepAlive: true },
	},
	{
		path: '/noticeRichDetail',
		name: 'noticeRichDetail',
		component: () => import('@/views/pages/noticeRichDetail'),
		meta: { title: '资讯详情', keepAlive: true },
	},
	{
		path: '/coreQualification',
		name: 'coreQualification',
		component: () => import('@/views/pages/coreQualification'),
		meta: { title: '中心实验室入室申请', keepAlive: true },
	},
	
	{
		path: '/register',
		name: 'register',
		component: () => import('@/views/pages/login/register.vue'),
		meta: { title: '注册', keepAlive: true },
	},
	{
		path: '/centerLab',
		name: 'centerLab',
		component: () => import('@/views/pages/centerLab.vue'),
		meta: { title: '中心实验室', keepAlive: true },
	},
	{
		path: '/animalLab',
		name: 'animalLab',
		component: () => import('@/views/pages/animalLab.vue'),
		meta: { title: '动物实验中心', keepAlive: true },
	},
	{
		path: '/pointLab',
		name: 'pointLab',
		component: () => import('@/views/pages/pointLab.vue'),
		meta: { title: '省重点实验室', keepAlive: true },
	},
	{
		path: '/orderLab',
		name: 'orderLab',
		component: () => import('@/views/pages/orderLab.vue'),
		meta: { title: '其他科研平台', keepAlive: true },
	},
	{
		path: '/largeIns',
		name: 'largeIns',
		component: () => import('@/views/pages/largeIns.vue'),
		meta: { title: '大型仪器简介', keepAlive: true },
	},
	{
		path: '/database',
		name: 'database',
		component: () => import('@/views/pages/database.vue'),
		meta: { title: '资料库', keepAlive: true },
	},
	{
		
		path: '/core/workbench',
		name: 'core',
		component: () => import('@/views/pages/core.vue'),
		 meta: { title: '个人中心', keepAlive: true, icon: 'home'},
		children: [{
			path: '/core/workbench',
			name: 'workbench',
			component: () => import('@/views/pages/coreDetail/workbench.vue'),
			 meta: { title: '工作台', keepAlive: true},
		}, {
			path: '/core/training',
			name: 'training',
			component: () => import('@/views/pages/coreDetail/training.vue'),
			meta: { title: '我的培训报名', keepAlive: true},
		},
		
		{
			path: '/core/onlineExam',
			name: 'onlineExam',
			component: () => import('@/views/pages/coreDetail/onlineExam.vue'),
			 meta: { title: '我的线上考试', keepAlive: true},
		},
		{
			
			path: '/core/personalData',
			name: 'personalData',
			component: () => import('@/views/pages/coreDetail/personalData.vue'),
			 meta: { title: '个人资料', keepAlive: true},
		},
		{
			path: '/core/aniQualificationCore',
			name: 'aniQualificationCore',
			component: () => import('@/views/pages/coreDetail/aniQualificationCore.vue'),
			meta: { title: '我的动物实验资格申请', keepAlive: true},
		},
		{
			path: '/core/coreQualificationCore',
			name: 'coreQualificationCore',
			component: () => import('@/views/pages/coreDetail/coreQualificationCore.vue'),
			meta: { title: '我的中心实验室入室申请', keepAlive: true},
		},
		
		{
			path: '/core/welfare',
			name: 'welfare',
			component: () => import('@/views/pages/coreDetail/welfare.vue'),
			meta: { title: '我的福利伦理审查', keepAlive: true},
		},
		{
			path: '/core/reviewChange',
			name: 'reviewChange',
			component: () => import('@/views/pages/coreDetail/reviewChange.vue'),
			meta: { title: '新增动物实验伦理说明', keepAlive: true},
		},
		{
			path: '/core/aniApplication',
			name: 'aniApplication',
			component: () => import('@/views/pages/coreDetail/aniApplication.vue'),
			meta: { title: '我的动物订购申请', keepAlive: true},
		},
		{
			
			path: '/core/instrumentCore',
			name: 'instrumentCore',
			component: () => import('@/views/pages/coreDetail/instrument.vue'),
			meta: { title: '我的仪器预约', keepAlive: true},
		},
		{
			path: '/core/operationRoomCore',
			name: 'operationRoomCore',
			component: () => import('@/views/pages/coreDetail/operationRoom.vue'),
			meta: { title: '我的场地预约', keepAlive: true},
		},
		{
			path: '/core/accessControlCore',
			name: 'operationRoomCore',
			component: () => import('@/views/pages/coreDetail/accessControl.vue'),
			meta: { title: '我的门禁预约', keepAlive: true},
		},
		{
		
			path: '/core/expense',
			name: 'expense',
		component: () => import('@/views/pages/coreDetail/expense.vue'),
			meta: { title: '费用明细', keepAlive: true},
		},
		{
			
			path: '/core/aniExpense',
			name: 'aniExpense',
			component: () => import('@/views/pages/coreDetail/aniExpense'),
			meta: { title: '费用明细', keepAlive: true},
		},
		{
			
			path: '/core/research',
			name: 'research',
			component: () => import('@/views/pages/coreDetail/research.vue'),
			meta: { title: '课题组', keepAlive: true},
		},
		{
			
			path: '/core/ethicsChange',
			name: 'ethicsChange',
			component: () => import('@/views/pages/coreDetail/ethicsChange.vue'),
			meta: { title: '伦理新增申请', keepAlive: true},
		},
		{
		
			path: '/core/opeRecord',
			name: 'opeRecord',
			component: () => import('@/views/pages/coreDetail/opeRecord'),
			meta: { title: '我的上机记录', keepAlive: true},
		},
		{
		
			path: '/core/updatePass',
			name: 'updatePass',
			component: () => import('@/views/pages/coreDetail/updatePass'),
			meta: { title: '修改密码', keepAlive: true},
		},
		{
		
			path: '/core/updatePhone',
			name: 'updatePhone',
			component: () => import('@/views/pages/coreDetail/updatePhone'),
			meta: { title: '修改手机', keepAlive: true},
		},
		{
			
			path: '/core/entryMsg',
			name: 'entryMsg',
			component: () => import('@/views/pages/coreDetail/entryMsg'),
			meta: { title: '入室信息', keepAlive: true},
		},
		{
			
			path: '/core/experData',
			name: 'experData',
			component: () => import('@/views/pages/coreDetail/experData'),
			meta: { title: '实验数据', keepAlive: true},
		},
		{
			
			path: '/core/deliveryTest',
			name: 'deliveryTest',
			component: () => import('@/views/pages/coreDetail/deliveryTest.vue'),
			meta: { title: '送样检测订单', keepAlive: true},
		},
		{
			
			path: '/core/integrityRecord',
			name: 'integrityRecord',
			component: () => import('@/views/pages/coreDetail/integrityRecord'),
			meta: { title: '诚信记录', keepAlive: true},
		},
		{
			
			path: '/core/consumable',
			name: 'consumable',
			component: () => import('@/views/pages/coreDetail/consumableCore.vue'),
			meta: { title: '我的耗材订单', keepAlive: true},
		},
		{
			
			path: '/core/monthlySum',
			name: 'monthlySum',
			component: () => import('@/views/pages/coreDetail/monthlySum'),
			meta: { title: '月度汇总', keepAlive: true},
		},
		{
			
			path: '/core/ownLimit',
			name: 'ownLimit',
			component: () => import('@/views/pages/coreDetail/ownLimit'),
			meta: { title: '我的权限', keepAlive: true},
		},
		{
			
			path: '/core/deliveryTestDetail',
			name: 'deliveryTestDetail',
			component: () => import('@/views/pages/coreDetail/deliveryTestDetail'),
			meta: { title: '检测单详情', keepAlive: true},
		},
		]
	}
]

const router = new VueRouter({
	// mode: 'hash',
	base: process.env.BASE_URL,
	routes
})
const MAX_INACTIVE_TIME = 7 * 24 * 60 * 60 * 1000; // 最大的非活动时间，7天的毫秒数
let timer = null;
router.beforeEach((to, from, next) => {
  // 每次路由导航之前重置计时器
  resetTimer();
  // 继续路由导航
  next();
});
function resetTimer() {
  // 清除计时器
  if (timer) {
    clearTimeout(timer);
  }
  // 重新开始计时
  timer = setTimeout(() => {
    clearLocalStorage();
  }, MAX_INACTIVE_TIME);
}
function clearLocalStorage() {
  // 清除所有的 localStorage
  localStorage.clear();
}
export default router
